import "#lib/client_exception_notifier.js";

if (!window.Asserter) {
  window.Asserter = class Asserter {
    static exists(selector) {
      return jQuery(selector).length;
    }

    constructor(options) {
      this.element = this.element.bind(this);
      this.presence = this.presence.bind(this);
      this.condition = this.condition.bind(this);
      this.failAssertion = this.failAssertion.bind(this);
      this.options = jQuery.extend({}, options);
    }

    element(selector, { limit, ...options } = {}) {
      const element = jQuery(selector);
      const count = element.length;

      if (limit && count > limit) {
        this.failAssertion(`Found ${count} elements matching '${selector}' but only allowed ${limit}`, options);
      } else if (count == 0) {
        this.failAssertion(`Element not found '${selector}'`, options);
      }

      return element;
    }

    presence(value, message, options) {
      if (value) {
        return value;
      }
      this.failAssertion(message, options);
    }

    condition(condition, message, options) {
      if (condition) {
        return true;
      }
      this.failAssertion(message, options);
    }

    failAssertion(message, options) {
      options = jQuery.extend({ userMessage: message }, this.options, options);
      var notifierOptions = {
        text: options.userMessage,
        description: options.description,
        canDescribe: false,
        notifyUser: options.notifyUser,
        reportData: options.reportData,
        throwException: false,
        recoveryFunction: options.recoveryFunction,
      };

      ClientExceptionNotifier.notify(message, notifierOptions);

      // Ensure we halt execution
      console.error(message);
      throw message;
    }
  };
} else {
  console.debug("Asserter already loaded");
}
